import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./Login/Login";
import Register from "./Login/Register";
import Home from "./Home/Home";
import ProtectedRoute from "./ProtectedRoute";
import { useAccountContext } from "./AccountContextProvider";
import { Text } from "@chakra-ui/react";

function Views() {
  const { loggedIn } = useAccountContext();

  const [backendReady, setBackendReady] = useState(false);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const res = await fetch(process.env.REACT_APP_SERVER_URL);

        if (res.ok) {
          setBackendReady(true);
          clearInterval(interval);
        }
      } catch (e) {
        console.log("Backend is still waking up...");
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  if (loggedIn === null || !backendReady) {
    return (
      <div style={{ padding: "20px" }}>
        <Text fontSize="2xl" fontWeight="bold">
          Starting server...
        </Text>

        <Text mt={4}>
          This demo uses Render's free tier. The backend may take up to 60
          seconds to wake up after inactivity.
        </Text>

        <Text mt={2}>Please wait while the application starts.</Text>
      </div>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="*" element={<Login />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />{" "}
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default Views;
